import { createSelector } from 'reselect';


export const deleteUserSelector = createSelector(
  (state: any) => state.deleteUser,
  (deleteUser) => deleteUser,
);

